module.exports = __webpack_public_path__ + "static/media/block-2-brisbane.3c2a5bbf.png";